import { Client, Room } from "@colyseus/sdk";
import { MallState, JoinOptions } from "@mall-mart/shared";

export class ColyseusClient {
  private client: Client;
  private room: Room<MallState> | undefined;

  constructor(serverUrl: string) {
    this.client = new Client(serverUrl);
  }

  async join(options: JoinOptions): Promise<Room<MallState>> {
    const room: Room<MallState> = await this.client.joinOrCreate<MallState>("mall", options);
    this.room = room;
    return room;
  }

  sendMove(x: number, y: number, z: number, rotation: number): void {
    if (this.room === undefined) {
      return;
    }
    this.room.send("move", { x, y, z, rotation });
  }

  leave(): void {
    this.room?.leave();
    this.room = undefined;
  }
}
